module.exports = __webpack_public_path__ + "4c6b2c0f4d2384112d12d3ff102acffd.pdf";